import { Flex, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

import { DateTimeCell } from 'src/components'

import { EVENT_KIND_COLORS, TICKER_VISIBLE } from './constants'
import { useStyles } from './styles'
import type { LiveEvent } from './types'

const { Text } = Typography

type Props = {
  feed: LiveEvent[]
  nodeLabels: Record<string, string>
  onSelect: (id: string) => void
}

export const ActivityTicker = ({ feed, nodeLabels, onSelect }: Props) => {
  const { styles } = useStyles()
  const { t } = useTranslation()

  const visible = feed.slice(0, TICKER_VISIBLE)

  return (
    <div className={styles.liveCard}>
      <div className={styles.tickerHead}>
        <span className={`${styles.tickerLiveDot} cg-live-dot`} aria-hidden />
        {t('workspaceOverview.companyGraph.liveActivity')}
      </div>
      <div className={styles.liveList} aria-live="polite">
        {visible.map((ev) => (
          <div key={ev.id} className={styles.liveRow}>
            <span
              className={styles.tickerDot}
              style={{ background: EVENT_KIND_COLORS[ev.kind], marginTop: 5 }}
              aria-hidden
            />
            <div className={styles.liveRowMain}>
              <Flex align="center" justify="space-between" gap={6}>
                <Text
                  className={styles.tickerNode}
                  ellipsis
                  onClick={() => onSelect(ev.nodeId)}
                >
                  {nodeLabels[ev.nodeId] ?? ev.nodeId}
                </Text>
                <DateTimeCell
                  value={ev.ts}
                  variant="relative"
                  style={{ fontSize: 10.5, flex: '0 0 auto' }}
                />
              </Flex>
              <Text className={styles.liveRowText}>{ev.text}</Text>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
